<script type="text/javascript">

    import {http} from '../../../system/http.js';
    import { getQueryParam } from '../../../system/helpers/index.js';
    import GoogleAnalyticsEvents from 'Modules/GoogleAnalytics/resources/assets/js/GoogleAnalyticsEvents';

    export default {

        data: function () {

            return {
                active: false,
                requiredLogin: false,
                phone_email: '',
                multiple_clients_login: 0,
                multiple_clients_registration: 0,
                new_registration: 0,
                submitted: null,
                permalink: permalink,
                loading: false,
                user: '',
                can_use_analytics: false,
                danmark: null,
            }

        },

        mounted: function () {
            this.$event_bus.$on('LoadData', (data) => {
                this.can_use_analytics = data.can_use_analytics;
            });

            this.$event_bus.$on('codeSent2', (data) => {
                this.user = data.user;
                this.phone_email = data.phone_email;
                this.multiple_clients_login = data.multiple_clients_login;
                this.multiple_clients_registration = data.multiple_clients_registration;
                this.new_registration = data.new_registration;
                this.submitted = data.submitted;
                this.danmark = data.danmark;
            });
        },

        methods: {
            codeSubmitted() {
                const dataFrm = new FormData($('#pin-frm')[0]);
                this.loading = true;

                http.post('/book/' + this.permalink + '/login', dataFrm)
                    .then(({data}) => {
                        if (this.new_registration && this.can_use_analytics) {
                            GoogleAnalyticsEvents.ClientRegistered.send();
                        }

                        this.loading = false;

                        if (data.clients) {
                            this.$event_bus.$emit('chooseLoginUser', data);
                        } else {
                            const redirectTo = data.redirect_to;
                            if (redirectTo) {
                                window.location.href = redirectTo;
                                return;
                            }

                            // check if we're on the '/book/<permalink>/center' page and if so,
                            // it means that the 1st step is login, so we need to refresh the page after
                            if (window.location.pathname.endsWith('/' + this.permalink + '/center')) {
                                location.reload();
                                return;
                            }

                            // Use the backend flag to determine login flow type
                            if (data.login_at_the_end_of_flow) {
                                // This is "login at end of flow" - so we login on the fly, and don't reload the page
                                this.$event_bus.$emit('loginSuccess', data);
                            } else {
                                // This is "required login at start" - reload the page
                                location.reload();
                            }
                        }
                    })
                    .catch(({ error, errorBag }) => {
                        this.loading = false;
                        if (error.response && error.response.status === 429) {
                            swal({
                                title: trans('global.error_title'),
                                text: trans('online_booking.rate_limit_client_failed_pin'),
                                showCancelButton: false,
                                showLoaderOnConfirm: true,
                                closeOnConfirm: true,
                            }, () => {});
                        }

                        this.$setErrorBag(errorBag);
                    });

            },

            goLoginOrSignUp() {
                this.$event_bus.$emit('goLoginOrSignUp');
            }
        },

    };


</script>


<template id="login-code">
    <div class="row">
        <div class="col-sm-8 col-sm-offset-2">
            <div class="card-box login-box">
                <div class="text-center">
                    <h4 class="text-uppercase font-bold m-b-0">
                        {{ trans('online_booking.pin_code') }}
                    </h4>
                </div>
                <div class="panel-body">
                    <form v-on:submit.prevent="codeSubmitted" id="pin-frm" class="form-horizontal m-t-20">

                        <input type="hidden" name="phone_email" :value="phone_email" />
                        <input type="hidden" name="multiple_clients_login" :value="multiple_clients_login" />
                        <input type="hidden" name="multiple_clients_registration" :value="multiple_clients_registration" />
                        <input type="hidden" name="new_registration" :value="new_registration" />
                        <input type="hidden" name="danmark" :value="danmark" />

                        <div v-if="new_registration">
                            <input type="hidden" name="name" :value="submitted.name" />
                            <input type="hidden" name="email" :value="submitted.email" />
                            <input type="hidden" name="phone" :value="submitted.phone" />
                            <input type="hidden" name="notes" :value="submitted.notes" />
                            <input type="hidden" name="address" :value="submitted.address" />
                            <input type="hidden" name="city" :value="submitted.city" />
                            <input type="hidden" name="zip" :value="submitted.zip" />
                            <input type="hidden" name="cpr" :value="submitted.cpr" />
                            <input type="hidden" name="dob" :value="submitted.dob" />
                        </div>

                        <div v-if="submitted && submitted.custom_attributes && Object.keys(submitted.custom_attributes).length">
                            <input
                                v-for="(customFieldValue, customFieldName) in submitted.custom_attributes"
                                :key="customFieldName"
                                type="hidden"
                                :name="`custom_attributes[${customFieldName}]`"
                                :value="customFieldValue">
                        </div>

                        <ep-banner class="mb-6">
                            <i class="zmdi zmdi-info-outline m-r-10 alert-ico"></i>
                            <span>{{ trans('online_booking.code_sent_1') }} <b>{{ phone_email }}</b>.</span>
                            <br>
                            <strong class="alert-indent">{{ trans('online_booking.code_sent_1.1') }}</strong>
                        </ep-banner>

                        <div class="form-group" :class="{ 'has-error' : errors.has('pin') }">
                            <div class="col-xs-12">
                                <input class="form-control" type="text" name="pin"
                                       :placeholder="trans('online_booking.write_pin_code')" autocomplete="off">
                                <span v-if="errors.has('pin')" class="help-block m-b-5">{{ errors.first('pin') }}</span>
                                <p v-if="!errors.has('pin')">{{ trans('online_booking.code_sent_2_1', { user }) }}<br>{{ trans('online_booking.code_sent_2_2', { user }) }}</p>
                            </div>
                        </div>

                        <div class="form-group text-center m-t-20">
                            <div class="col-xs-12">
                                <button class="btn btn-custom btn-lg btn-block" type="button" @click="codeSubmitted()" v-if="!loading">
                                    {{ trans('online_booking.confirm_and_create') }}
                                </button>
                                <div class="btn btn-lg btn-custom btn-block btn-login-loading" v-if="loading">
                                    <div class="preloader"></div>
                                </div>
                            </div>
                        </div>

                        <div class="form-group m-b-0">
                            <div class="col-sm-12 m-t-20 choose-user-bottom">
                                <a class="btn btn-default" @click="goLoginOrSignUp()">
                                    <i class="zmdi zmdi-chevron-left m-r-10 alert-ico"></i>
                                    {{ trans('global.back') }}
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>
